import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserToken } from '../hooks/useToken';
const AuthenticateRoute = () => {
  const { token } = useUserToken();

  if (token) {
    // Access granted
    return <Outlet />;
  } else {
    return <Navigate to={'/'} />;
  }
};

export default AuthenticateRoute;
